import { Dispatch } from "redux";
import { actions } from "./index";

const { notification, resetNotification } = actions;

const setAuthSnackbar =
    ({ snackbarOpen, snackbarType, snackbarMessage }: any): any =>
    async (dispatch: Dispatch) => {
        dispatch(notification({ snackbarOpen, snackbarType, snackbarMessage }));
    };

const NotificationActions = {
    notification:
        (payload: any): any =>
        async (dispatch: Dispatch) => {
            try {
                dispatch(
                    setAuthSnackbar({
                        snackbarOpen: true,
                        snackbarType: payload.snackbarType,
                        snackbarMessage: payload.snackbarMessage,
                    })
                );
            } catch (error) {
                throw new Error(error);
            }
        },
    resetNotification: () => async (dispatch: Dispatch) => {
        dispatch(resetNotification());
    },
};

export default NotificationActions;
